import { createActions } from 'redux-actions';

export const { showPaymentModal } = createActions({
  showPaymentModal: (values, callbacks) => ({ values, callbacks }),
}, { prefix: 'PAYMENT_MODAL' });
